'use client'

import { useEffect, useState } from 'react'
import Script from 'next/script'
import { siteLocale, Locale } from '@marketing-sites/utils'

export function NetReviewsWidgetSimple() {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  const widgetIds = {
    [Locale.au]: {
      id: '6647e521-0c96-4b8f-bbe5-f6821668b944',
      src: '50945da0-2d38-0c34-e94a-343a41bd0bc8/6647e521-0c96-4b8f-bbe5-f6821668b944.js',
    },
    [Locale.nz]: {
      id: '6647e521-0c96-4b8f-bbe5-f6821668b944',
      src: '50945da0-2d38-0c34-e94a-343a41bd0bc8/6647e521-0c96-4b8f-bbe5-f6821668b944.js',
    },
    [Locale.ca]: {
      id: '989b2b4a-8325-45e8-a0ff-bca1efd917cf',
      src: '30b8ea9a-c6f0-0744-2960-fce382688fb8/989b2b4a-8325-45e8-a0ff-bca1efd917cf.js',
    },
    [Locale.uk]: {
      id: '77bc9e44-a907-440c-8ca1-f96f4c93b828',
      src: '6f9d21df-594a-6464-7d72-6348f0fff7cd/77bc9e44-a907-440c-8ca1-f96f4c93b828.js',
    },
    [Locale.us]: {
      id: '989b2b4a-8325-45e8-a0ff-bca1efd917cf',
      src: '30b8ea9a-c6f0-0744-2960-fce382688fb8/989b2b4a-8325-45e8-a0ff-bca1efd917cf.js',
    },
    [Locale.za]: {
      id: '77bc9e44-a907-440c-8ca1-f96f4c93b828',
      src: '6f9d21df-594a-6464-7d72-6348f0fff7cd/77bc9e44-a907-440c-8ca1-f96f4c93b828.js',
    },
  }

  const widget = widgetIds[siteLocale as keyof typeof widgetIds]

  return isClient ? (
    <>
      <div id={widget.id}></div>
      <Script src={`https://widgets.rr.skeepers.io/generated/${widget.src}`} />
    </>
  ) : null
}
